import React from 'react';

////////// ASC FOR DOCUMENTS SIZE START ////////////

const roundFileSize = (size, precision) => {

    if (isNaN(size)) {
        return size;
    }

    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;

    while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index++;
    }

    return `${Number(size)?.toFixed(precision)} ${units[index]}`;
};

///////// ASC FOR DOCUMENTS SIZE END ////////////


export default roundFileSize